import { Grid, Paper, Chip } from '@material-ui/core';
import {
  Assignment as AssignmentIcon,
  CheckCircle,
  DateRange,
  Description as DescriptionIcon,
  Event as EventIcon,
  Group,
  HomeWork as HomeWorkIcon,
  Loop,
  MenuBookRounded,
  Person as PersonIcon,
  SchoolRounded as SchoolIcon,
  VpnKey as VpnKeyIcon,
  Work as WorkIcon,
} from '@material-ui/icons';
import { getStatsClassRoom, getTrainingById, getCode, getPlanningByClassroom } from '@webapps/business';
import { Button, useQuery, useRouter } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedMessage } from 'react-intl';

import theme from '../theme';
import ActionClasse from './ActionsClasse';
import { css } from '@emotion/css';
import ClassesCardSkeleton from './ClassesCardSkeleton';

const {
  colors: { itemColor },
} = theme;

const ClassesCard = ({ endDate, id, isLoading, label, refetch, startDate, trainingId, handleOpenExportModal }) => {
  const { classes, global, cx, theme: { spacing } } = useStyles(styles);


  if (isLoading) {
    return <ClassesCardSkeleton />;
  }

  const { push } = useRouter();

  const handleOpenClasses = () => {
    push(ROUTES_PATH.SCHOOL_CLASSES_DETAIL, { params: { id, trainingId } });
  };

  const { data: stats = {} } = useQuery(getStatsClassRoom, {
    key: ['statClass', id],
    variables: { id },
  });


  const { data: invite = {} } = useQuery(getCode, {
    key: ['classroomCode', id],
    variables: { id, type: 'classroom' },
  });


  const { data: planning = {} } = useQuery(getPlanningByClassroom, {
    key: ['planning', id],
    variables: { id },
  });

  const { data: training = {} } = useQuery(getTrainingById, {
    key: ['training', trainingId],
    variables: { id: trainingId },
  });

  const calculateCodeDate = (expireAt, status) => {
    const newDate = new Date();

    const currentDate = new Date(newDate).getTime();
    const expirationDate = new Date(expireAt).getTime();

    if (currentDate > expirationDate || status === "Expired") {
      return '(Expiré)';
    }

    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    const daysRemaining = Math.ceil((expirationDate - currentDate) / millisecondsPerDay);

    return `(${daysRemaining} j.)`;
  }

  return (
    <Grid item xs={12} md={4} lg={3} style={{ padding: spacing(2.5, 2.5, 0, 0) }}>
      <Paper className={classes.paper} >
        <div className={classes.items}>
          <div className={classes.cardItemHeader}>
            <div className={global.title}>
              {label}
            </div>
            <div>
              <ActionClasse
                from="list"
                id={id}
                nbrStudent={stats?.totalMembers}
                refetch={refetch}
                handleOpenExportModal={handleOpenExportModal}
              />
            </div>
          </div>
          <div className={classes.cardItem}>
            <SchoolIcon className={global.infoIcon} />
            <div className={global.infoText}>{training?.degree?.label}</div>
          </div>
          <div className={classes.cardItem}>
            <WorkIcon className={global.infoIcon} />
            <div className={global.infoText}>{training?.label}</div>
          </div>
          <div className={classes.cardItem}>
            <MenuBookRounded className={global.infoIcon} />
            <div className={global.infoText}>
              <span>{training?.domain?.label}</span>
            </div>
          </div>
          <div className={classes.cardItem}>
            <DescriptionIcon className={global.infoIcon} />
            <div className={global.infoText}>
              <span>{training?.trainingType?.label}</span>
            </div>
          </div>
          <div className={classes.cardItem}>
            <Group className={global.infoIcon} />
            <div className={global.infoText}>{stats?.totalMembers < 2 ? `${stats?.totalMembers} Apprenant` : `${stats?.totalMembers} Apprenants`}</div>
          </div>

          <div className={classes.cardItem}>
            <CheckCircle className={global.infoIcon} />
            <div className={global.infoText}>
              {stats?.studentsAtWork < 2 ? `${stats?.studentsAtWork} Apprenant en entreprise` : `${stats?.studentsAtWork} Apprenants en entreprise`}
            </div>
          </div>
          <div className={classes.cardItem}>
            <DescriptionIcon
              className={global.infoIcon}
            />
            <div className={global.infoText}>
              {stats?.toSendContracts < 2 ? `${stats?.toSendContracts} Contrat à envoyer` : `${stats?.toSendContracts} Contrats à envoyer`}
            </div>
          </div>
          <div className={classes.cardItem}>
            <DescriptionIcon
              className={global.infoIcon}

            />
            <div className={global.infoText}>
              {stats?.toSignContracts < 2 ? `${stats?.toSignContracts} Contrat en attente de votre signature` : `${stats?.toSignContracts} Contrats en attente de votre signature`}
            </div>
          </div>
          <div className={classes.cardItem}>
            <DescriptionIcon className={global.infoIcon} />
            <div className={global.infoText}>
              {stats?.pendingContracts < 2 ? `${stats?.pendingContracts} Contrat en attente des autres parties` : `${stats?.pendingContracts} Contrats en attente des autres parties`}
            </div>
          </div>
          <div className={classes.cardItem}>
            <DateRange className={global.infoIcon} />
            <div className={global.infoText}>
              <FormattedDate
                day="numeric"
                month="numeric"
                value={startDate}
                year="numeric"
              />{' '}
              au{' '}
              <FormattedDate
                day="numeric"
                month="numeric"
                value={endDate}
                year="numeric"
              />
            </div>
          </div>
          <div className={classes.cardItem}>
            <Loop className={global.infoIcon} />
            <div className={global.infoText}>
              <span>
                {training?.trainingType?.label === 'Alternance' ? (training?.rythmAlternance.length > 5 ?
                  training.rythmAlternance.split('/').map((part, index) =>
                    index === 0
                      ? `${part.trim()} école`
                      : `${part.trim()} entreprise`
                  ).join(' / ') : 'Non renseigné')
                  : training?.trainingType?.label === 'Formation initiale' ? 'Cycle initial' : 'Cycle continu'
                }
              </span>
            </div>
          </div>
          <div className={classes.cardItem}>
            <VpnKeyIcon className={global.infoIcon} />
            <div className={global.infoText}>
              {invite?.code ? `Code d'invitation : ${invite?.code} ${calculateCodeDate(invite?.expireAt, invite?.status)}` : 'Aucun code'}
            </div>
          </div>
        </div>
        <div className={classes.buttons}>
          {!planning?.periods ? (
            <Button className={classes.buttonHover} onClick={() => push(`${ROUTES_PATH.SCHOOL_CLASSES_DETAIL}??planning=true`, { params: { id, trainingId } })} variant="outlined" style={{ border: '1px solid #0060F9', color: '#0060F9', fontWeight: 600, marginTop: spacing(2) }}>Configurer le planning</Button>
          ) : (
            <Chip
              classes={{
                colorPrimary: css({
                  background: '#dbfad8',
                  color: 'green',
                  marginTop: spacing(1),
                  width: 'fit-content',
                  height: '40px',
                  fontSize: '14px',
                  lineHeight: '1.2',
                }),
              }}
              color="primary"
              label="Planning configuré"
              size="small"
            />
          )
          }
        </div>
        <div className={classes.buttons}>
          <Button onClick={handleOpenClasses} variant="outlined" style={{ border: '1px solid #C0D9FF', color: '#5A6DA1', fontWeight: 600, marginTop: spacing(2) }}>
            <FormattedMessage id="school.classes.result.card.button" />
          </Button>
        </div>
      </Paper>
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  paper: {
    padding: spacing(2.5),
    borderRadius: 10,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'none',
  },
  cardItem: {
    display: 'flex',
    marginTop: spacing(0.5),
    alignItems: 'center',
  },
  cardItemHeader: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
  },
  itemText: {
    color: "#5D75A8",
  },
  buttonHover: {
    "&:hover": {
      backgroundColor: "#0060F9",
      color: "white!important",
    },
  }
});

ClassesCard.propTypes = {
  label: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  id: PropTypes.string,
  training: PropTypes.string,
  refetch: PropTypes.func,
};

export default ClassesCard;
